import api from '../lib/axios';
import { downloadFile } from '../lib/download';
export async function getSchools() {
    const { data } = await api.get('/api/admin/schools');
    return data;
}
export async function upsertSchoolOverride(uai, body) {
    const { data } = await api.patch(`/api/admin/schools/${uai}`, body);
    return data.data;
}
export async function resetSchoolOverride(uai) {
    await api.delete(`/api/admin/schools/${uai}`);
}
export async function getSchoolMenus(uai, week) {
    const { data } = await api.get(`/api/admin/schools/${uai}/menus`, { params: week ? { week } : undefined });
    return data;
}
export function downloadMenuTemplate(uai) {
    return downloadFile(`/api/admin/schools/${uai}/menu-template`, `menus_template_${uai}.xlsx`);
}
export async function importMenus(uai, file) {
    const formData = new FormData();
    formData.append('file', file);
    const { data } = await api.post(`/api/admin/schools/${uai}/menus/import`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
    return data;
}
export async function saveMenuImage(uai, week, body) {
    const { data } = await api.put(`/api/admin/schools/${uai}/menus/image`, body, { params: { week } });
    return data.data;
}
export async function deleteMenuImage(uai, week) {
    await api.delete(`/api/admin/schools/${uai}/menus/image`, { params: { week } });
}
